// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__6iQUQ","child1":"style_child1__fhRPH","child2":"style_child2__GzxOe"};